export default "/static/opentrons_heater_shaker_tiny.png";